import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/corner-right-up.svg'
import _imports_1 from '@/assets/img/Icons/left-arrow-blue.svg'
import _imports_2 from '@/assets/img/Icons/right-arrow-blue.svg'


const _withScopeId = n => (_pushScopeId("data-v-5c91be2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title-container"
}
const _hoisted_2 = { class: "left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Up one level",
  width: "16",
  height: "16"
}, null, -1))
const _hoisted_4 = { class: "right" }
const _hoisted_5 = ["title"]
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.previousTeamScoreboard)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            class: "back",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickBackTo()))
          }, [
            _hoisted_3,
            _createTextVNode(" Back to " + _toDisplayString(_ctx.backToText), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            title: _ctx.siblingGroups.prev ? _ctx.siblingGroups.prev.group : '',
            class: "prev",
            src: _imports_1,
            alt: "prev",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTeamScoreboard(_ctx.siblingGroups.prev)))
          }, null, 8, _hoisted_5),
          _createElementVNode("img", {
            title: _ctx.siblingGroups.next ? _ctx.siblingGroups.next.group : '',
            class: "next",
            src: _imports_2,
            alt: "next",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchTeamScoreboard(_ctx.siblingGroups.next)))
          }, null, 8, _hoisted_6)
        ])
      ]))
    : _createCommentVNode("", true)
}